export function numberToSimpleNumberString(value, type) {
  if (type === "percentage") {
    return value + "%";
  }

  let output = "";
  if (value < 1000) {
    output =  "" + value;
  } else if (value < 1000000) {
    //  thousands
    let thousandsValue = value / 1000;
    thousandsValue = thousandsValue.toFixed(1);
    output =  "" + thousandsValue + "K";
  } else {
    //  millions
    let milValue = value / 1000000;
    milValue = milValue.toFixed(2);
    output =  milValue.substring(0, milValue.length - 1) + "M";
  }

  if(type === "currency") {
    output = "£" + output;
  }

  if(type === "minutes") {
    output = output + " min";
  }

  return output;
}
